import { render, staticRenderFns } from "./RoomCallP2P.vue?vue&type=template&id=1dcbd7d2&scoped=true&"
import script from "./RoomCallP2P.vue?vue&type=script&lang=js&"
export * from "./RoomCallP2P.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallP2P.vue?vue&type=style&index=0&id=1dcbd7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcbd7d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcbd7d2')) {
      api.createRecord('1dcbd7d2', component.options)
    } else {
      api.reload('1dcbd7d2', component.options)
    }
    module.hot.accept("./RoomCallP2P.vue?vue&type=template&id=1dcbd7d2&scoped=true&", function () {
      api.rerender('1dcbd7d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/p2p/RoomCallP2P.vue"
export default component.exports